// Author Lin
// Date 2022-06-15 17:00:56

class SithMesInventoryManualInput {
constructor({
        id = null,
        manualCheckId = '',
        inputQuantity = '',
        inputTime = '',
        inputLogin = '',
        remark = ''}
= {}) {
    this.id = id;
    this.manualCheckId = manualCheckId;
    this.inputQuantity = inputQuantity;
    this.inputTime = inputTime;
    this.inputLogin = inputLogin;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryManualInput();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'manualCheckId',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.manualCheckId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inputQuantity',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.inputQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inputTime',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.inputTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inputLogin',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.inputLogin',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inputName',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.inputName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualInput.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    manualCheckIdFilter : '',
    inputQuantityFilter : '',
    inputTimeRteFilter : '',
    inputTimeLteFilter : '',
    inputLoginFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'manualCheckIdFilter',
        label: 'label.sith.inventory.sithMesInventoryManualInput.filter.manualCheckId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesInventoryManualCheck'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inputQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryManualInput.filter.inputQuantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inputTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualInput.filter.inputTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inputTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualInput.filter.inputTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inputLoginFilter',
        label: 'label.sith.inventory.sithMesInventoryManualInput.filter.inputLogin',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'manualCheckId',
        label: 'label.sith.inventory.sithMesInventoryManualInput.entity.manualCheckId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesInventoryManualCheck'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inputQuantity',
        label: 'label.sith.inventory.sithMesInventoryManualInput.entity.inputQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inputTime',
        label: 'label.sith.inventory.sithMesInventoryManualInput.entity.inputTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inputLogin',
        label: 'label.sith.inventory.sithMesInventoryManualInput.entity.inputLogin',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualInput.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryManualInput, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
